<template>
  <el-form-item
    :label="item.label"
    :prop="`${item.field}`"
    :hidden="item.options.hidden"
    v-if="item.showed"
    :rules="[
      {
        required: item.required || false,
        message: item.label + '为必填字段',
      },
    ]"
  >
    <el-radio-group v-model="$attrs.model[item.field]">
      <el-radio v-for="(radio, index) in item.options.valueData" :key="index" :label="radio.code" :disabled="item.options.disabled">{{ radio.label }}</el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
export default {
  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped></style>
